<script>
    import SimpleSelect from '../SimpleSelect.svelte';
    import { INSTALLED_STATUSES } from 'src/constants/mx/installed-status';

    export let value;

    $: items = Object.entries(INSTALLED_STATUSES).map(([label, value]) => ({ value, label }));
</script>

<SimpleSelect
    {items}
    bind:value
/>
